﻿import $ from 'jquery';

declare global {
  interface JQuery {
    scrollto(option, args): any;
  }
}

export class ScrollTo {
  public static get attribute(): string { return 'scroll-to'; }
  public static get wireup(): string { return ScrollTo.attribute.asDataSelector() }

  public static execute($element: JQuery) {
    let $container = $element.closest('scroll-to-container'.asDataSelector($element.data(ScrollTo.attribute)));
    if ($container.length == 0)
      $container = $element.parent();

    if ($container.is('body'))
      throw new Error('body cannot be a container');

      var shouldScroll = !ScrollTo.isInView($element[0], $container[0]);

      if (shouldScroll) {
        $container.scrollTop($element.offset().top - $container.offset().top + $container.scrollTop());
        $element.data('rustig.scrollto.scrolled', true);
      }
  }

    private static isInView(element, container) : boolean {
      let elementRect = element.getBoundingClientRect();
      let elementTop = elementRect.top;
      let elementHeight = elementRect.height;
      let elementBottom = elementTop + elementHeight;

      let parent = container;
      let parentRect = parent.getBoundingClientRect();
      let isElementTopBelowParentBottom = parentRect.bottom < elementTop === true;
      let isElementBottomAboveParentTop = elementBottom <= parentRect.top;
      let isOutOfParentView = isElementTopBelowParentBottom || isElementBottomAboveParentTop;

      return !isOutOfParentView;
    }

}

function Plugin(option, args) {
  return this.each(function () {
    ScrollTo.execute($(this));
  });
}

$.fn.scrollto = Plugin;
